import { type ReactNode, useMemo } from 'react'

import { context, type FormOptionsContext } from './context'

type Props = {
	children: ReactNode
	showChangedFields: boolean
	showOptionalHint: boolean
}

export const FormOptionsProvider = ({ children, showChangedFields, showOptionalHint }: Props) => {
	const value = useMemo<FormOptionsContext>(
		() => ({
			showChangedFields,
			showOptionalHint,
		}),
		[showChangedFields, showOptionalHint],
	)

	return <context.Provider value={value}>{children}</context.Provider>
}
